<template>
<div>
    <router-link
        :to="{ name: 'gateways_details', params: { hashid: row.id, gateway_source : this.slug}}"
        class="btn btn-sm btn-clean btn-icon btn-icon-sm">
        <i class="fa fa-eye"></i>
    </router-link>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        slug() {
            return this.$router.history.current.name;
        }
    },
    methods : {},
})
</script>

<style>

</style>